import { CONTEST_WIZARD_INITIAL, ContestWizardState } from './types';

const DRAFT_KEY = 'thspian_brand_contest_wizard_draft_v1';

type SerializableDraft = Omit<
    ContestWizardState,
    'feature_image_file' | 'mobile_feature_image_file' | 'contest_media_files'
> & {
    step: number;
    savedAt: string;
    createdContestId?: string | null;
};

export function loadContestWizardDraft(): {
    state: ContestWizardState;
    step: number;
    createdContestId: string | null;
} | null {
    try {
        const raw = localStorage.getItem(DRAFT_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as SerializableDraft;
        const { step, savedAt: _savedAt, createdContestId, ...rest } = parsed;
        return {
            step: typeof step === 'number' ? step : 0,
            createdContestId: typeof createdContestId === 'string' ? createdContestId : null,
            state: {
                ...CONTEST_WIZARD_INITIAL,
                ...rest,
                feature_image_file: null,
                mobile_feature_image_file: null,
                contest_media_files: [],
            },
        };
    } catch {
        return null;
    }
}

export function saveContestWizardDraft(
    state: ContestWizardState,
    step: number,
    createdContestId?: string | null,
): void {
    try {
        const {
            feature_image_file: _f,
            mobile_feature_image_file: _m,
            contest_media_files: _c,
            ...serializable
        } = state;
        const payload: SerializableDraft = {
            ...serializable,
            step,
            savedAt: new Date().toISOString(),
            ...(createdContestId ? { createdContestId } : {}),
        };
        localStorage.setItem(DRAFT_KEY, JSON.stringify(payload));
    } catch {
        /* ignore quota */
    }
}

export function clearContestWizardDraft(): void {
    try {
        localStorage.removeItem(DRAFT_KEY);
    } catch {
        /* ignore */
    }
}
